<script lang="ts">
  import {onMount} from 'svelte';
  import {slide} from 'svelte/transition';

  let open = true;
  let timeout: any;
  onMount(() => {
    timeout = setTimeout(() => {
      open = false;
    }, 15000);
  });

  function toggle() {
    open = !open;
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  }
</script>

<div
  class="absolute left-2 top-3 z-50 flex w-[304px] space-x-[12px] overflow-hidden border-l-4 border-orange-500 bg-[#FFFAF6] px-[16px] py-[12px]"
  style="font-family:Roboto"
>
  <div class="block pt-[2px]">
    <i class="fa fa-spinner animate-spin text-lg font-extrabold text-orange-500" />
  </div>
  <div class="flex flex-grow flex-col space-y-[8px]">
    <div class="flex w-full items-center justify-center align-middle">
      <b class="block text-[18px] font-semibold">Rendering in progress...</b>
      <div class="ml-auto block cursor-pointer" on:click={toggle} on:keypress={toggle}>
        {#if open}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.7472 10.5355C11.9081 10.6964 11.9986 10.9148 11.9986 11.1424C11.9986 11.37 11.9081 11.5884 11.7472 11.7493C11.5862 11.9103 11.3679 12.0007 11.1403 12.0007C10.9126 12.0007 10.6943 11.9103 10.5333 11.7493L6 7.21455L1.46523 11.7479C1.30427 11.9089 1.08595 11.9993 0.858315 11.9993C0.630676 11.9993 0.41236 11.9089 0.251395 11.7479C0.0904294 11.5869 3.39209e-09 11.3686 0 11.141C-3.39209e-09 10.9133 0.0904295 10.695 0.251395 10.5341L4.78616 6.00071L0.252823 1.46595C0.0918572 1.30498 0.00142808 1.08667 0.00142808 0.859029C0.00142808 0.63139 0.0918572 0.413074 0.252823 0.252109C0.413788 0.0911434 0.632104 0.000713906 0.859743 0.000713904C1.08738 0.000713902 1.3057 0.0911434 1.46666 0.252109L6 4.78687L10.5348 0.251394C10.6957 0.0904292 10.914 -3.79247e-09 11.1417 0C11.3693 3.79247e-09 11.5876 0.0904292 11.7486 0.251394C11.9096 0.41236 12 0.630675 12 0.858315C12 1.08595 11.9096 1.30427 11.7486 1.46524L7.21384 6.00071L11.7472 10.5355Z"
              fill="#71717A"
            />
          </svg>
        {:else}
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.29414 13.2066C7.68477 13.5973 8.31914 13.5973 8.70977 13.2066L14.7098 7.20664C15.1004 6.81602 15.1004 6.18164 14.7098 5.79102C14.3191 5.40039 13.6848 5.40039 13.2941 5.79102L8.00039 11.0848L2.70664 5.79414C2.31602 5.40352 1.68164 5.40352 1.29102 5.79414C0.900391 6.18477 0.900391 6.81914 1.29102 7.20977L7.29102 13.2098L7.29414 13.2066Z"
              fill="#A1A1AA"
            />
          </svg>
        {/if}
      </div>
    </div>
    {#if open}
      <div transition:slide={{axis: 'y'}} class="space-y-2 text-[16px] leading-[24px]">
        <p class="">
          You're previewing a low-resolution version while the full-quality video is being prepared. The final version
          will be available shortly.
        </p>
        <p class="">You may continue editing like normal.</p>
        <p class="">
          <span class="text-sm font-semibold">Note: </span>If compiling takes more than 5 minutes, please consider
          re-uploading your video from a file and turn on the Resync option
        </p>
      </div>
    {/if}
  </div>
</div>
